import { get } from "lodash";
import Dinero from "dinero.js";
import { PureComponent } from "react";
import { PropTypes } from "prop-types";

import { COST_FORMAT } from "../../config.js";

class FormattedCharge extends PureComponent {
  static propTypes = {
    chargeData: PropTypes.object
  };

  // -- RENDER -- //

  render() {
    const chargeValue = get(this.props, "chargeData.value", undefined);
    const chargeCurrency = get(this.props, "chargeData.currency", undefined);

    if ((chargeValue || chargeValue === 0) && chargeCurrency) {
      return Dinero({
        amount: Math.round(chargeValue), // safety, this should be prerounded by the api
        currency: chargeCurrency
      }).toFormat(COST_FORMAT);
    }

    return null;
  }
}

export default FormattedCharge;
